
<script>
  import { Doughnut  , mixins } from "vue-chartjs";
  export default {
    mixins: [mixins.reactiveData, mixins.reactiveProp],
    extends: Doughnut ,
    props: {
      chartData: {
        type: Array | Object,
        required: false
      } ,
      chartLabels: {
        type: Array,
        required: true
      } 
       ,
      chartColors: {
        type: Array,
        required: true
      } 
    },
    data () {
      return {
        options: {          
          tooltips: {
            
            callbacks: {
             // title: tooltipItem => {
             //   return `🗓 ${tooltipItem[0].xLabel}`
             // },
              label: (t, d) => {
                debugger;
                 var label = d.labels[t.index];
                 var valor = d.datasets[t.datasetIndex].data[t.index];
                  var yLabel = valor >= 1000 ? '$' + valor.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") : '$' + label;
                  return label + ': ' + yLabel;
              }
            }
          }, 
          legend: {
            display: true,
            position: 'left',            
          },
          responsive: false,
          maintainAspectRatio: true
        },
          
      }
    },
    mounted () {
      this.renderChart({
         labels: this.chartLabels,
        datasets: [
          {
            borderWidth: 1,
            borderColor: this.chartColors,            
            backgroundColor: this.chartColors,            
            data: this.chartData,
          }/*,
           {
            label: 'Abastible',
            borderColor: '#FF9800',
            pointBackgroundColor: '#FF9800',
            borderWidth: 1,
            pointBorderColor: '#FF9800',
            backgroundColor: '#FF9800',
            fill: false,
            data: this.chartAbastible,
            lineTension: 0.1,
          },
           {
            label: 'Lipigas',
            borderColor: '#ffc107',
            pointBackgroundColor: '#ffc107',
            borderWidth: 1,
            pointBorderColor: '#ffc107',
            backgroundColor: '#ffc107',
            fill: false,
            data: this.chartLipigas,
            lineTension: 0.1,
          }*/
        ],
        
      }, this.options)
    },
     watch: {
    data: function() {
      this._chart.destroy();
      //this.renderChart(this.data, this.options);
       this.renderChart({
        labels: this.chartLabels,
        datasets: [
          {
            
            borderColor: this.chartColors,            
            backgroundColor: this.chartColors,            
            data: this.chartData,
          }/*,
           {
            label: 'Abastible',
            borderColor: '#FF9800',
            pointBackgroundColor: 'white',
            borderWidth: 1,
            pointBorderColor: '#FF9800',
            backgroundColor: '#FF9800',
            data: this.chartAbastible
          },
           {
            label: 'Lipigas',
            borderColor: '#FFFF00',
            pointBackgroundColor: 'white',
            borderWidth: 1,
            pointBorderColor: '#FFFF00',
            backgroundColor: '#FFFF00',
            data: this.chartLipigas
          }*/
        ]
      }, this.options)
    }
  }
  }
  
</script>
 